/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EContentHidingMode } from './EContentHidingMode';
import {
    EContentHidingModeFromJSON,
    EContentHidingModeFromJSONTyped,
    EContentHidingModeToJSON,
} from './EContentHidingMode';
import type { SuiviActionEditDto } from './SuiviActionEditDto';
import {
    SuiviActionEditDtoFromJSON,
    SuiviActionEditDtoFromJSONTyped,
    SuiviActionEditDtoToJSON,
} from './SuiviActionEditDto';
import type { SuiviFichierGridDto } from './SuiviFichierGridDto';
import {
    SuiviFichierGridDtoFromJSON,
    SuiviFichierGridDtoFromJSONTyped,
    SuiviFichierGridDtoToJSON,
} from './SuiviFichierGridDto';

/**
 * 
 * @export
 * @interface SuiviHopeEditDto
 */
export interface SuiviHopeEditDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idsuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idservice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idrealisateurSuivi?: number;
    /**
     * 
     * @type {string}
     * @memberof SuiviHopeEditDto
     */
    userService?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    creationUser?: number;
    /**
     * 
     * @type {string}
     * @memberof SuiviHopeEditDto
     */
    encodeur?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SuiviHopeEditDto
     */
    dateSuivi?: Date;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idapprenant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idformateur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idrepresentant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idchefEntreprise?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idtuteur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idcontact?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviHopeEditDto
     */
    apprenant?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idcontrat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idtypeSuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idsousTypeSuivi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    iddecisionCommissionTutelle?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idmode?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idsiegeSocial?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idlieuRencontre?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviHopeEditDto
     */
    contenu?: string | null;
    /**
     * 
     * @type {EContentHidingMode}
     * @memberof SuiviHopeEditDto
     */
    contentHidingMode?: EContentHidingMode;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviHopeEditDto
     */
    action?: boolean;
    /**
     * 
     * @type {SuiviActionEditDto}
     * @memberof SuiviHopeEditDto
     */
    suiviAction?: SuiviActionEditDto;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idcentre?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviHopeEditDto
     */
    fromSmile?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idmetier?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviHopeEditDto
     */
    idlieuFormation?: number | null;
    /**
     * 
     * @type {Array<SuiviFichierGridDto>}
     * @memberof SuiviHopeEditDto
     */
    fichiers?: Array<SuiviFichierGridDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviHopeEditDto
     */
    fromCct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviHopeEditDto
     */
    fromCctScreening70?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviHopeEditDto
     */
    fromCctScreening90?: boolean;
}

/**
 * Check if a given object implements the SuiviHopeEditDto interface.
 */
export function instanceOfSuiviHopeEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviHopeEditDtoFromJSON(json: any): SuiviHopeEditDto {
    return SuiviHopeEditDtoFromJSONTyped(json, false);
}

export function SuiviHopeEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviHopeEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'idservice': !exists(json, 'idservice') ? undefined : json['idservice'],
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : json['idrealisateurSuivi'],
        'userService': !exists(json, 'userService') ? undefined : json['userService'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'encodeur': !exists(json, 'encodeur') ? undefined : json['encodeur'],
        'dateSuivi': !exists(json, 'dateSuivi') ? undefined : (new Date(json['dateSuivi'])),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idrepresentant': !exists(json, 'idrepresentant') ? undefined : json['idrepresentant'],
        'idchefEntreprise': !exists(json, 'idchefEntreprise') ? undefined : json['idchefEntreprise'],
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'apprenant': !exists(json, 'apprenant') ? undefined : json['apprenant'],
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'idtypeSuivi': !exists(json, 'idtypeSuivi') ? undefined : json['idtypeSuivi'],
        'idsousTypeSuivi': !exists(json, 'idsousTypeSuivi') ? undefined : json['idsousTypeSuivi'],
        'iddecisionCommissionTutelle': !exists(json, 'iddecisionCommissionTutelle') ? undefined : json['iddecisionCommissionTutelle'],
        'idmode': !exists(json, 'idmode') ? undefined : json['idmode'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'idlieuRencontre': !exists(json, 'idlieuRencontre') ? undefined : json['idlieuRencontre'],
        'contenu': !exists(json, 'contenu') ? undefined : json['contenu'],
        'contentHidingMode': !exists(json, 'contentHidingMode') ? undefined : EContentHidingModeFromJSON(json['contentHidingMode']),
        'action': !exists(json, 'action') ? undefined : json['action'],
        'suiviAction': !exists(json, 'suiviAction') ? undefined : SuiviActionEditDtoFromJSON(json['suiviAction']),
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'fromSmile': !exists(json, 'fromSmile') ? undefined : json['fromSmile'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'fichiers': !exists(json, 'fichiers') ? undefined : (json['fichiers'] === null ? null : (json['fichiers'] as Array<any>).map(SuiviFichierGridDtoFromJSON)),
        'fromCct': !exists(json, 'fromCct') ? undefined : json['fromCct'],
        'fromCctScreening70': !exists(json, 'fromCctScreening70') ? undefined : json['fromCctScreening70'],
        'fromCctScreening90': !exists(json, 'fromCctScreening90') ? undefined : json['fromCctScreening90'],
    };
}

export function SuiviHopeEditDtoToJSON(value?: SuiviHopeEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuivi': value.idsuivi,
        'idservice': value.idservice,
        'idrealisateurSuivi': value.idrealisateurSuivi,
        'userService': value.userService,
        'creationUser': value.creationUser,
        'encodeur': value.encodeur,
        'dateSuivi': value.dateSuivi === undefined ? undefined : (value.dateSuivi.toISOString()),
        'idapprenant': value.idapprenant,
        'idformateur': value.idformateur,
        'idrepresentant': value.idrepresentant,
        'idchefEntreprise': value.idchefEntreprise,
        'idtuteur': value.idtuteur,
        'idcontact': value.idcontact,
        'apprenant': value.apprenant,
        'idcontrat': value.idcontrat,
        'idtypeSuivi': value.idtypeSuivi,
        'idsousTypeSuivi': value.idsousTypeSuivi,
        'iddecisionCommissionTutelle': value.iddecisionCommissionTutelle,
        'idmode': value.idmode,
        'idsiegeSocial': value.idsiegeSocial,
        'idlieuRencontre': value.idlieuRencontre,
        'contenu': value.contenu,
        'contentHidingMode': EContentHidingModeToJSON(value.contentHidingMode),
        'action': value.action,
        'suiviAction': SuiviActionEditDtoToJSON(value.suiviAction),
        'idcentre': value.idcentre,
        'fromSmile': value.fromSmile,
        'idmetier': value.idmetier,
        'idlieuFormation': value.idlieuFormation,
        'fichiers': value.fichiers === undefined ? undefined : (value.fichiers === null ? null : (value.fichiers as Array<any>).map(SuiviFichierGridDtoToJSON)),
        'fromCct': value.fromCct,
        'fromCctScreening70': value.fromCctScreening70,
        'fromCctScreening90': value.fromCctScreening90,
    };
}

